import { takeLatest, put, call, cancelled } from 'redux-saga/effects';
import {
  ITALIAN_ORDER_PRICE_ENTRIES_REQUEST,
  FOREIGN_ORDER_PRICE_ENTRIES_REQUEST,
  REQUEST_PRICE_LIST_DEFAULT_START,
} from '../actions';

angular.module('tct.sagas.priceLists', [])
  .factory('priceListsSagaFactory', priceListsSagaFactory);

priceListsSagaFactory.$inject = ['$ngRedux',
  'priceEntriesService',
  'actionsFactory',
  'mappingService',
];

function priceListsSagaFactory($ngRedux, priceEntriesService, actionsFactory, mappingService) {
  const factory = {
    getItalianEntriesFlow,
    getForeignEntriesFlow,
    getDefaultPriceListFlow,
  };

  return factory;

  function* getPriceEntriesForItalianCompany(action) {
    try {
      const response = yield call(
        priceEntriesService.getPriceListForItalianCompany, action.searchEntry);
      yield put(actionsFactory.italianOrderPriceEntriesSuccess(
        mappingService.objectKeysToCamel(response.data.data.entries || []),
        response.data.data.available_credits));
    } catch (error) {
      yield put(actionsFactory.italianOrderPriceEntriesFailed());
    } finally {
      if (yield cancelled()) {
        console.log('cancelled');
      }
    }
  }

  function* getPriceEntriesForForeignCompany(action) {
    try {
      const response = yield call(
        priceEntriesService.getPriceListForForeignCompany, action.searchEntry, action.countryCode);
      yield put(actionsFactory.foreignOrderPriceEntriesSuccess(
        mappingService.objectKeysToCamel(response.data.data.entries || []),
        response.data.data.available_credits));
    } catch (error) {
      yield put(actionsFactory.foreignOrderPriceEntriesFailed());
    } finally {
      if (yield cancelled()) {
        console.log('cancelled');
      }
    }
  }

  function* getDefaultPriceList(action) {
    try {
      const defaultPriceListRes = yield call(priceEntriesService.getDefaultPriceList);
      const defaultPriceList = defaultPriceListRes.data && defaultPriceListRes.data.data;
      yield put(actionsFactory.reqPriceListDefaultSuccess(defaultPriceList));
      return defaultPriceListRes;
    } catch (err) {
      yield put(actionsFactory.reqPriceListDefaultError());
    } finally {
      if (yield cancelled()) {
        console.log('cancelled');
      }
    }

    return action;
  }

  function* getItalianEntriesFlow() {
    yield takeLatest(ITALIAN_ORDER_PRICE_ENTRIES_REQUEST, getPriceEntriesForItalianCompany);
  }

  function* getForeignEntriesFlow() {
    yield takeLatest(FOREIGN_ORDER_PRICE_ENTRIES_REQUEST, getPriceEntriesForForeignCompany);
  }

  function* getDefaultPriceListFlow() {
    yield takeLatest(REQUEST_PRICE_LIST_DEFAULT_START, getDefaultPriceList);
  }
}
